import { gql, TypedDocumentNode } from "@apollo/client";
import { TrendingJewelry, TrendingJewelryCreateInput, TrendingJewelryUpdateInput } from '../type/trending-jewelry'

export const FindTrendingJewelry: TypedDocumentNode<{trendingJewelryFind: TrendingJewelry[]}> = gql`
    query FindTrendingJewelry {
        trendingJewelryFind {
            id
            item {
                id
                sku
                description
            }
            displayOrder
        }
    }
`

export const CreateTrendingJewelry: TypedDocumentNode<void, {input: TrendingJewelryCreateInput}> = gql`
    mutation CreateTrendingJewelry ($input: TrendingJewelryCreateInput!) {
        trendingJewelryCreate(input: $input)
    }
`

export const UpdateTrendingJewelry: TypedDocumentNode<void , {input: TrendingJewelryUpdateInput[]}>= gql`
    mutation UpdateTrendingJewelry ($input: [TrendingJewelryUpdateInput !]!) {
        trendingJewelryUpdate(input:$input)
    }
`

export const DeleteTrendingJewelry: TypedDocumentNode<void, {id: number}> = gql`
    mutation DeleteTrendingJewelry ($id: Int!) {
        trendingJewelryDelete(id: $id)
    }
`
